module.exports = "<select ng-options=\"data.id as data.title for data in $selectData\"\n        ng-table-select-filter-ds=\"$column\"\n        ng-disabled=\"$filterRow.disabled\"\n        ng-model=\"params.filter()[name]\"\n        class=\"filter filter-select form-control\" name=\"{{name}}\">\n    <option style=\"display:none\" value=\"\"></option>\n</select>\n";


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-table/src/browser/filters/select.html
// module id = 2151
// module chunks = 2